interface Props {
  mobileSrc: string;
  desktopSrc: string;
  className?: string;
  alt: string;
}

const ResponsiveImage = ({ mobileSrc, desktopSrc, alt, className }: Props) => {
  return (
    <picture data-testid="picture">
      <source
        data-testid="source"
        media="(min-width: 767px)"
        srcSet={desktopSrc}
      />
      <img alt={alt} className={className} src={mobileSrc} />
    </picture>
  );
};

export default ResponsiveImage;
